import { fromJS } from 'immutable';

import { combineReducerArray } from '../utils/helpers';

import listReducerObject from './list/reducer';
import marketplaceReducerObject from './marketplace/reducer';
import networkSignupReducerObject from './networkSignup/reducer';
import onboardingReducerObject from './onboarding/reducer';
import openIdReducerObject from './openIdSignup/reducer';
import signupReducerObject from './signup/reducer';

import { ME_REQUEST, ME_SUCCESS, ME_FAILURE, patchUserPreferences } from './types';

const initialState = fromJS({
  list: {
    data: [],
    network: {
      loading: false,
      error: false,
      success: false,
    },
  },
  marketplace: {
    apiKey: {
      data: null,
      network: {
        loading: false,
        error: false,
        success: false,
      },
    },
    questionnairePrefill: {
      network: {
        loading: false,
        error: false,
        success: false,
      },
    },
    modal: {
      open: false,
      options: {},
    },
    matchesResultsData: {
      byId: {},
    },
    matchesResults: {
      byId: {},
      network: {
        loading: false,
        error: false,
        success: false,
      },
    },
  },
  network: {
    loading: true,
    error: false,
  },
  networkSignup: {
    network: {
      data: null,
      network: {
        loading: true,
        error: false,
        success: false,
      },
    },
    signup: {
      network: {
        loading: false,
        error: false,
        success: false,
      },
    },
  },
  onboardingCompleted: {
    network: {
      loading: false,
      error: false,
    },
  },
  openId: {
    login: {
      network: {
        loading: false,
        error: false,
        success: false,
      },
    },
    openId: {
      data: null,
      network: {
        loading: false,
        error: false,
        success: false,
      },
    },
    signup: {
      network: {
        loading: false,
        error: false,
        success: false,
      },
    },
  },
  signup: {
    network: {
      loading: false,
      error: false,
      success: false,
    },
  },
  user: false,
});

export function meRequest() {
  return {
    type: ME_REQUEST,
  };
}

export function meSuccess(user) {
  return {
    type: ME_SUCCESS,
    user,
  };
}

export function meFailure(error) {
  return {
    type: ME_FAILURE,
    error,
  };
}

const userReducer = {
  [ME_REQUEST]: (state) => state.setIn(['network', 'loading'], true),
  [ME_SUCCESS]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false)
        .set('user', fromJS(action.user)),
    ),
  [ME_FAILURE]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], action.error)
        .set('user', false),
    ),
  [patchUserPreferences.request]: (state, action) =>
    state.setIn(['user', 'profile', 'preferences', action.key], action.value),
};

export default combineReducerArray(initialState, [
  listReducerObject,
  marketplaceReducerObject,
  networkSignupReducerObject,
  onboardingReducerObject,
  openIdReducerObject,
  signupReducerObject,
  userReducer,
]);
